<template>
  <step-display :current-step="2">
    <more-info />
  </step-display>
</template>

<script>
import StepDisplay from "@/components/global/StepDisplay";
import MoreInfo from "@/components/steps/MoreInformation";

export default {
  name: "MoreInformation",
  components: {
    StepDisplay,
    MoreInfo,
  },
}
</script>

<style scoped>

</style>